import { axiosGet, axiosPost } from "../../../../../react_axios/Axios";
import { INSERT_AND_UPDATE_PR_AGENCY_ACTION_TYPE, GET_PR_AGENCY_DETAILS_ACTION_TYPE, headers, getPrAgencyDetailsUrl, insertUpdatePrAgencyUrl } from "../../../../../utils/constants";

export const insertUpdatePrAgency_action =
  (
    PRAgencyFormID,
    IsRequiredPRAgency,
    Remark,
    IsAgree,
    ManualFormID,
    ServiceID,
    VendorDetails,
    StatusID,
    IsInvoicePaid
  ) =>
  async (dispatch) => {
    try {
      const params = {
        UserID: JSON.parse(sessionStorage.getItem("loginDataSS")).UserID,
        ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
        ExhRegistrationID: sessionStorage.getItem("ExhRegistrationIDSS"),
        PRAgencyFormID: PRAgencyFormID != "" ? PRAgencyFormID : null,
        IsRequiredPRAgency: IsRequiredPRAgency,
        Remark: Remark,
        IsAgree: IsAgree,
        ManualFormID: ManualFormID,
        ServiceID: ServiceID,
        VendorDetails: VendorDetails,
        StatusID: StatusID || 0,
        IsInvoicePaid: IsInvoicePaid || false,
      };
      const res = await axiosPost(insertUpdatePrAgencyUrl, params, headers);

      dispatch({
        type: INSERT_AND_UPDATE_PR_AGENCY_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error);
    }
  };

export const getPrAgencyDetails_action = () => async (dispatch) => {
  try {
    const params = {
      UserID: JSON.parse(sessionStorage.getItem("loginDataSS")).UserID,
      ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
      ExhRegistrationID: sessionStorage.getItem("ExhRegistrationIDSS"),
    };
    const res = await axiosGet(getPrAgencyDetailsUrl, params, headers);

    dispatch({
      type: GET_PR_AGENCY_DETAILS_ACTION_TYPE,
      payload: res,
    });
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error);
  }
};
